/* The Sunday Hound 2.0 Core Motion */

(function () {
  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initReveal(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var items = scope.querySelectorAll('[data-tsh-reveal]');

    if (!items.length) return;

    if (prefersReducedMotion()) {
      items.forEach(function (item) {
        item.classList.add('is-visible');
      });
      return;
    }

    document.documentElement.classList.add('tsh-motion');

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.14,
        rootMargin: '0px 0px -56px 0px'
      }
    );

    items.forEach(function (item) {
      if (item.dataset.tshRevealBound === 'true') return;
      item.dataset.tshRevealBound = 'true';
      observer.observe(item);
    });
  }

  function init(root) {
    initReveal(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();